import { RandomEngine } from './RandomEngine';
export class JSRandomEngine extends RandomEngine
{
  public next()
  {
    return Math.random();
  }

  private static _instance = new JSRandomEngine();
  static get $()
  {
    return JSRandomEngine._instance;
  }
}